import { useRoute, computed, defineComponent, getCurrentInstance, useContext, useCssModule, } from '@nuxtjs/composition-api';
import { useTask } from 'vue-concurrency';
import { useDuck } from '~/services';
import { useAsyncRef, cachePage, createHead, pluralize } from '~/utils';
import { PODCASTS_PARTNERS } from '~/components/PodcastPartner';
const PODCASTS_LIMIT = 10;
const duck = useDuck();
// const taskFetchPodcasts = useTask(function* () {
//   //
// })
function formatPodcasts(input = [], url = '') {
    return input.map((item) => {
        return {
            date: Number(item.time) * 1000,
            description: item.subtitle,
            file: item.podcast_file,
            isPartner: url in PODCASTS_PARTNERS(),
            key: item.issue || 0,
            serial: item.serial || {},
            title: item.title,
            url: `/${item.url_alias}`,
        };
    });
}
export default defineComponent({
    name: 'PagePodcastsPodcast',
    setup() {
        /**
         * Context.
         */
        const context = useContext();
        /**
         * CSS Modules.
         */
        const css = useCssModule();
        /**
         * Viewport.
         */
        const viewport = context.$viewport;
        const route = useRoute();
        const podcastHeaderTheme = computed(() => {
            return viewport.isLessThan('tablet') ? 'dark' : 'light';
        });
        const instance = getCurrentInstance();
        const podcast = useAsyncRef(instance, 'podcast');
        const taskFetchPodcastsNext = useTask(function* () {
            if (taskFetchPodcastsNext.isRunning) {
                return;
            }
            const { data } = yield duck.pub.getPubTax({
                'list[limit]': PODCASTS_LIMIT,
                'list[offset]': podcast.value?.podcasts?.length || 0,
                'tax[url]': route.value.path.replace(/^\/|\/$/g, ''),
            });
            const podcasts = formatPodcasts(data.articles, data.url);
            if (podcasts.length < PODCASTS_LIMIT) {
                podcast.value.isDone = true;
            }
            podcast.value.podcasts = [...podcast.value.podcasts, ...podcasts];
        });
        return {
            css,
            podcastHeaderTheme,
            taskFetchPodcastsNext,
        };
    },
    async asyncData(context) {
        const { app, env, error, redirect, req, res, route } = context;
        try {
            const path = route.path.replace(/^\/|\/$/g, '');
            const { data } = await duck.pub.getPubTax({
                'list[limit]': PODCASTS_LIMIT,
                'tax[url]': path,
            });
            // @ts-ignore
            if (data.url_alias && data.url_alias !== path) {
                // @ts-ignore
                return redirect(`/${data.url_alias}`);
            }
            if (data.url && data.url !== path) {
                return redirect(`/${data.url}`);
            }
            const podcasts = formatPodcasts(data.articles, data.url);
            const podcast = {
                description: data.fields?.field_subtitle?.value || '',
                image: data.fields?.field_main_image?.value,
                isDone: podcasts.length < PODCASTS_LIMIT,
                isPartner: `${data.url}` in PODCASTS_PARTNERS(),
                podcasts,
                size: podcasts?.[0]?.key ? pluralize(podcasts[0].key, 'выпуск', 'выпуска', 'выпусков', true) : '',
                title: String(data.name),
                url: `${data.url}`,
            };
            let description = `${podcast.title} – слушайте подкаст «${podcast.title}»  на Forbes.ru`;
            if (podcast.description) {
                description = podcast.description.slice(0, 250);
            }
            const title = podcast.title + ' | Подкасты Forbes.ru';
            const head = {
                canonical: env.HOST + route.path,
                description,
                image: (podcast.image || {}).uri || '',
                title,
                url: env.HOST + route.path,
            };
            context.$page = app.$page = {
                title,
            };
            if (process.server) {
                cachePage({ date: podcast.podcasts[0].date, req, res });
            }
            return {
                $page: context.$page,
                head,
                podcast,
            };
        }
        catch (e) {
            console.error(e);
            error({ statusCode: 404 });
        }
    },
    head() {
        return createHead(this.head, { shouldUseTitleTemplate: false });
    },
});
